<template>
  <nuxt-link v-if="to" :to="to" class="btn" :class="classes">
    <div class="inline-block fill-current stroke-current">
      <slot name="icon"/>
    </div>
    <slot/>
  </nuxt-link>
  <a
    v-else-if="href"
    :href="href"
    rel="noopener"
    class="btn"
    :class="classes"
  >
    <div class="inline-block fill-current stroke-current">
      <slot name="icon"/>
    </div>
    <slot/>
  </a>
  <button v-else @click="$emit('click')"
          class="btn"
          :class="classes">
    <div class="inline-block fill-current stroke-current">
      <slot name="icon"/>
    </div>
    <slot/>
  </button>
</template>

<script>
  export default {
    name: 'UiButton',
    props: {
      to: {
        type: [String, Object],
        default: null
      },
      href: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'primary'
      },
      size: {
        type: String,
        default: 'm'
      },
      variant: {
        type: String,
        default: 'green'
      }
    },
    computed: {
      classes () {
        let classes = []
        classes.push(`btn-${this.type}`)
        classes.push(`btn-size-${this.size}`)

        return classes.join(' ')
        // if (this.variant === 'gray') {
        //   return 'bg-gray-200 text-nuxt-gray hover:bg-gray-300'
        // }
        // return 'bg-nuxt-lightgreen text-white hover:bg-nuxt-green'
      }
    }
  }
</script>

<style lang="scss">
  .btn {
    /*@apply text-mf-white inline-block font-medium text-sm px-4 py-2 shadow uppercase rounded hover:shadow-md;*/

    @apply inline-block visible p-0 text-center no-underline;

    box-sizing: border-box;
    font: inherit;
    border: 0;
    border-radius: 0;
    background: 0 0;
    color: inherit;
    user-select: none;

    &:focus, &:hover {
      outline: 0;
      -webkit-tap-highlight-color: transparent;
    }

    & > div:not(:empty) {
      @apply mr-1;
    }

    font-size: rem(14px);
    padding: 10px 15px;
    @screen md {
      font-size: rem(18px);
      padding: 10px 20px;
    }

    @include FontWeight(Medium);
    color: #fff;
    border: 1px solid transparent;
    border-radius: 24px;

  }

  .btn-primary {
    //background: $--color-violet;
    background: #27AE60;
    color: white;

    &:hover, &:active {
      border-color: #219653;
      background: #219653;
    }
  }

  .btn-secondary {
    background: transparent;
    //border-color: $--color-white;
    border-color: white;

   /* &:focus,*/ &:hover {
      border-color: rgba(255, 255, 255, .6);
    }
  }

  .btn-primary-green {
    //background: $--color-green;
    background: #00B956;

    /*&:focus,*/ &:hover {
      //background: lighten($--color-green, 5%);
      background: lighten(#00B956, 5%);
    }
  }

  .btn-transparent {
    @apply text-color-black bg-transparent;
    border: 1px solid rgba(51, 51, 51, 0.15);
  }

  .btn-size-l {
    padding-top: 17px;
    padding-bottom: 17px;
    border-radius: 30px;
  }

  .btn-transparent-bordered {
    border-color: #27AE60;
    color: #27AE60;
    background-color: transparent;

    &:hover, &:active {
      background-color: transparent;
      border-color: #219653;
      color: #219653;
    }

  }



</style>
